import { api } from "../../services/NetworkBase";

export async function GetSampleTypes() {
  try {
    let response = await api.get(`vlp/samples-maintenance/sample-types`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveSampleTypes(sampleType, turnaround) {	
  try {
    let response = await api
      .post(`vlp/samples-maintenance/sample-types`, {
        json: { samtype:sampleType, turnaround:turnaround },
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateSampleTypes(sampleType, turnaround) {	
  try {
    let response = await api
      .put(`vlp/samples-maintenance/sample-types`, {
        json: { samtype:sampleType, turnaround:turnaround },
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

//AddSampleBottle
export async function AddSampleBottle(bottle) {	
  try {
    let response = await api
      .post(`vlp/samples-maintenance/sample-bottles`, {
        json: bottle,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

//AddSampleBottle
export async function UpdateSampleBottle(bottle) {	
  try {
    let response = await api
      .put(`vlp/samples-maintenance/sample-bottles`, {
        json: bottle,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteSampleType(id) {
  try {
    let response = await api
      .delete(`vlp/samples-maintenance/sample-types/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
//DeleteSampleBottle
export async function DeleteSampleBottle(id) {
  try {
    let response = await api
      .delete(`vlp/samples-maintenance/sample-bottles/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteSampleMatrix(id) {
  try {
    let response = await api
      .delete(`vlp/samples-maintenance/sample-matrices/` + id)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
export async function GetSampleMatrices() {
  try {
    let response = await api
      .get(`vlp/samples-maintenance/sample-matrices`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetSampleBottles() {
  try {
    let response = await api
      .get(`vlp/samples-maintenance/sample-bottles`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetSampleType(userId) {
  try {
    let response = await api
      .get(`vlp/samples-maintenance/sample-types/${userId}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
